import React, { useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box, Chip } from '@mui/material';
import { green, orange, red } from "@mui/material/colors";

import { useToggle } from "hooks/useToggle";
import { newDateWithTime } from "helpers/dateTools"

import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from "@mui/icons-material/Cancel";
import DeleteIcon from "@mui/icons-material/Delete";

import RegularButton from 'components/CustomButtons/Button';
import { ModalV2 } from "components/Modal/ModalV2";
import { PERMISSIONS } from "router/permissions";

import { changeStatusCreditUnlockAction, deleteCreditUnlockAction } from "redux/actions/creditsUnlock/creditsUnlockActions";

const { CRM_UNLOCK_ACCOUNTS_SERVICE_AR } = PERMISSIONS

const ActionsCell = ({ original }) => {
  const { id, status_ticket } = original
  const dispatch = useDispatch()
  const { user, id: idUser, rules } = useSelector(({ login }) => login);
  const [openModal, setOpenModal] = useToggle()
  const [openCancel, setOpenCancel] = useToggle()
  const [isConfirmModal, setIsConfirmModal] = useState(false)
  const statusValid = status_ticket === "CREADO";

  const handleOpenModal = useCallback((val = false) => {
    setOpenModal()
    setIsConfirmModal(val)
  }, [setOpenModal])

  const handleChangeStatus = useCallback((e) => {
    e.preventDefault()
    const form = {
      statusTicket: isConfirmModal ? "APROBADO" : "RECHAZADO"
    }
    dispatch(changeStatusCreditUnlockAction(id, form, { name: user, id: idUser }, setOpenModal))
  }, [isConfirmModal, id, user, idUser, dispatch, setOpenModal])

  const handleDelete = useCallback(() => {
    dispatch(deleteCreditUnlockAction(original.id, setOpenCancel))
  }, [original.id, dispatch, setOpenCancel])

  return (
    <>
      <Box style={{
        display: "flex",
        justifyContent: "flex-end",
        flexWrap: 'wrap',
      }}>
        {rules.includes(CRM_UNLOCK_ACCOUNTS_SERVICE_AR) && statusValid ? (
          <>
            <RegularButton
              color="transparent"
              round
              justIcon
              tooltip="Aprobar"
              onClick={() => handleOpenModal(true)}
            >
              <CheckCircleIcon style={{ color: green[500] }} />
            </RegularButton>
            <RegularButton
              color="transparent"
              round
              justIcon
              tooltip="Rechazar"
              onClick={() => handleOpenModal(false)}
            >
              <CancelIcon style={{ color: orange[500] }} />
            </RegularButton>
            <RegularButton
              color="transparent"
              round
              justIcon
              tooltip="Eliminar"
              onClick={setOpenCancel}
            >
              <DeleteIcon style={{ color: red[500] }} />
            </RegularButton>
          </>
        ) : null}
      </Box>
      <ModalV2
        open={openModal}
        onClose={setOpenModal}
        title={isConfirmModal ? `¿Seguro que desea aprobar?` : `¿Seguro que desea rechazar?`}
        justConfirm
        onSubmit={handleChangeStatus}
      />
      <ModalV2
        open={openCancel}
        onClose={setOpenCancel}
        title={`¿Seguro que desea eliminar?`}
        justConfirm
        onSubmit={handleDelete}
        confirmText="Eliminar"
        confirmColor="danger"
      />
    </>
  )
}


export const columns = [
  {
    Header: 'Fecha',
    accessor: 'created_date',
    filterable: true,
    filterMethod: (filter, row) => row.created_date?.toString().includes(filter.value.toLowerCase()),
    Cell: ({ original }) => { return <div> {newDateWithTime({ date: original.created_date, format: true })} </div> }
  },
  {
    Header: 'Planta',
    accessor: d => d?.station?.name || "",
    id: 'stationName',
    filterable: true,
    filterMethod: (filter, row) => row[filter.id]?.toLowerCase().includes(filter.value.toLowerCase())
  },
  {
    Header: 'Cuenta',
    accessor: d => d?.account?.alias || "",
    id: 'accountAlias',
    filterable: true,
    filterMethod: (filter, row) => row[filter.id]?.toLowerCase().includes(filter.value.toLowerCase())
  },
  {
    Header: 'Código Cuenta',
    accessor: d => d?.account?.code || "",
    id: 'accountCode',
    filterable: true,
    filterMethod: (filter, row) => row[filter.id]?.toLowerCase().includes(filter.value.toLowerCase())
  },
  {
    Header: 'Justif.',
    accessor: 'comment',
    filterable: true,
    filterMethod: (filter, row) => row.comment?.toLowerCase().includes(filter.value.toLowerCase())
  },
  {
    Header: 'U. Solicitud',
    accessor: d => d?.user_created?.name || '',
    id: 'userCreatedName',
    filterable: true,
    filterMethod: (filter, row) => row[filter.id]?.toLowerCase().includes(filter.value.toLowerCase())
  },
  {
    Header: 'U. A/R',
    accessor: d => d?.user_a_r?.name || '',
    id: 'userARName',
    filterable: true,
    filterMethod: (filter, row) => row[filter.id]?.toLowerCase().includes(filter.value.toLowerCase())
  },
  {
    Header: 'Ser. Estatus',
    accessor: 'serviceStatus',
    filterable: true,
    filterMethod: (filter, row) => row.serviceStatus?.toLowerCase().includes(filter.value.toLowerCase())
  },
  {
    Header: 'Estatus',
    accessor: 'status_ticket',
    filterable: true,
    filterMethod: (filter, row) => row.status_ticket?.toLowerCase().includes(filter.value.toLowerCase()),
    Cell: ({ original }) => {
      return <Chip label={original.status_ticket} color={original.colorStatus} />
    }
  },
  {
    Header: 'Acciones',
    filterable: false,
    sortable: false,
    Cell: ({ original }) => <ActionsCell original={original} />,
  }
];
